function getPercent(value, maxValue) {
  return Math.min(100, Math.round((value * 100) / maxValue));
}

function getValueFromPercent(percent, maxValue) {
  return Math.ceil((percent * maxValue) / 100);
}

export default {
  getPercent,
  getValueFromPercent,
};
